import styled from "styled-components";
import { IComposerImgProps } from "./interfaces";

export const StyledTopBar = styled.div`
    height: 43px;
    display: flex;
    align-items: center;
`;

export const StyledTitle = styled.h3`
    margin: 0;
    font-size: 21px;
    font-weight: ${p => p.theme.mode === "dark" ? 400 : 600};
    color: ${p => p.theme.c.grey5};
    padding: 8px 10px;
    display: block;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const NotPlayable = styled.div`
    display: inline-block;
    cursor: pointer;
    padding: 5px;
    margin: -5px;
    margin-right: 0;
    white-space: normal;

    .i-alert {
        margin-top: 3px;
        color: ${p => p.theme.c.info};
        display: block;
        font-size: 16px;
        top: 2px;
        position: relative;
    }

    .Tooltip {
        position: absolute;
        z-index: 2;
        width: 220px;
        top: 34px;
        font-size: 16px;
        font-weight: 300;
        font-variant: normal;
        color: white;
        text-shadow: 0 0 3px ${p => p.theme.c.blackShadow4};
        border-radius: 5px;
        padding: 10px;
        line-height: 1.5;
        background-color: ${p => p.theme.c.info};
        text-align: justify;

        transition: 300ms;
        opacity: 0;
        pointer-events: none;

        &.Show {
            opacity: 1;
        }
    }
`;

export const ComposerImgWrapper = styled.div`
    display: inline-block;
    margin-left: 8px;
    margin-right: -4px;
    cursor: pointer;
    > div {
        display: block;
    }
`;

export const ComposerImg = styled.div<IComposerImgProps>`
    width: 26px;
    height: 26px;
    background-image: url(${p => p.src});
    background-size: cover;
    border-radius: 13px;
    flex-shrink: 0;
`;
